import axios from 'axios';

const API_URL = '/api/v1/rating/';

const ratingRequest = ({
	date,
	customerNumber,
	phoneNumber,
	callCenterId,
	initCallNotificationMessageId,
} = {}) => {
	return axios.post(`${API_URL}request`, {
		date,
		customerNumber,
		phoneNumber,
		callCenterId,
		initCallNotificationMessageId,
	});
};

export { ratingRequest };
